import { Component, Input, OnInit } from '@angular/core';
import { FlightJourney } from '@sabstravtech/obtservices/angular';

@Component({
  selector: 'app-cloned-details',
  templateUrl: './cloned-details.component.html',
  styleUrl: './cloned-details.component.scss',
  standalone: false
})
export class ClonedDetailsComponent implements OnInit {
  @Input() name: string;
  @Input() flights: FlightJourney[];
  flightNumbers: string;

  ngOnInit(): void {
    this.flightNumbers = (this.flights || [])
      .map((flight: FlightJourney) => flight.marketingFlightNumber)
      .join(', ');
  }
}
